import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { PainelinsumoService } from '../../../services/painelinsumo.service';
import { ToastService } from '../../../services/toast.service';
import { DepositoInsumo } from '../../../types/DepositoInsumo.type';
import { DepositoInsumoPosicao } from '../../../types/DepositoInsumoPosicao.type';
import { EstoqueErpOS } from '../../../types/EstoqueErpOS.type';
import { InsumoConsumidoOS } from '../../../types/InsumoConsumidoOS.type';
import { OrdemInsumo } from '../../../types/OrdemInsumo.type';
import { OrdemInsumoItems } from '../../../types/OrdemInsumoItems.type';
import { OrdemInsumoTransferencia } from '../../../types/OrdemInsumoTransferencia.type';
import { OrdemInsumoTransferenciaItem } from '../../../types/OrdemInsumoTransferenciaItem.type';

@Component({
  selector: 'app-transferencia',
  templateUrl: './transferencia.component.html',
  styleUrl: './transferencia.component.css',
})
export class TransferenciaComponent implements OnInit {
  ordemOrigem: OrdemInsumo = {} as OrdemInsumo;
  ordemDestino: OrdemInsumo = {} as OrdemInsumo;

  loadingDestino: boolean = false;
  loadingEstoqueERP: boolean = false;
  loadingOperacao: boolean = false;

  insumosConsumidos: InsumoConsumidoOS[] = [];
  insConsumidos: { [s: string]: Number } = {};

  transferencias: { [s: string]: OrdemInsumoTransferenciaItem } = {};
  titulo: string = "";
  descricao: string = "";
  botao: string = "";
  corBotao: string = "";

  depositos: DepositoInsumo[] = [];
  depositosOrigem: DepositoInsumo[] = [];
  depositosDestino: DepositoInsumo[] = [];

  depositoOrigem!: DepositoInsumo;
  depositoDestino: DepositoInsumo = {} as DepositoInsumo;
  posicaoDestino!: DepositoInsumoPosicao;

  tipoTransferencia: string = "";

  estoqueErp: EstoqueErpOS[] = [];
  estoqueMaterialErp: { [s: string]: Number } = {};

  constructor(
    private painelService: PainelinsumoService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    let id = this.activatedRoute.snapshot.paramMap.get('id');
    this.tipoTransferencia = this.activatedRoute.snapshot.paramMap.get('tipo') || ""

    this.config()

    if (id) {
      this.painelService.getOrdem(id).subscribe({
        next: (data) => {
          this.ordemOrigem = data;
          console.log(this.ordemOrigem);

          this.ordemOrigem.itens.forEach((item) => {
            let itemTransf: OrdemInsumoTransferenciaItem = {
              insumo: item.cdInsumo,
              quantidade: 0,
            };

            this.transferencias[item.cdInsumo] = itemTransf;
          });

          this.getDepositos(data.instancia);

          this.getInsumosBaixado(data.instancia, data.noOs, '');

          
        },
        error: (error) => {
          this.toastService.erro('Erro', 'Erro ao buscar: ' + error.message);
          console.log(error);
        },
        complete: () => {},
      });
    }
  }

  config(){
    switch(this.tipoTransferencia){
      case "T":
        this.titulo = "Transferência entre OS"
        this.descricao = "Transferências entre OS da mesma instância"
        this.botao = "Transferir"
        this.corBotao = "primary"
        break;
      case "D":
        this.titulo = "Devolução"
        this.descricao = "Baixa do insumo no ERP"
        this.botao = "Baixar"
        this.corBotao = "danger"
        break;
      case "R":
        this.titulo = "Retirada"
        this.descricao = "Retirada de material do depósito"
        this.botao = "Retirar"
        this.corBotao = "success"
        break;
    }
  }

  getEstoqueErp(){
    this.loadingEstoqueERP = true;

    let deposito = "";

    if(this.tipoTransferencia == "D")
      deposito = this.depositoOrigem.cdDepositoErp;
   

    this.painelService.getEstoqueErp(this.ordemOrigem.id, deposito).subscribe({
      next: (data) => {
        this.estoqueErp = data
        console.log(this.estoqueErp)
        
        data.forEach((e) => {
          this.estoqueMaterialErp[e.material] = e.quantidade
        })

        this.toastService.sucesso("", "Estoque carregado")
      },
      error: (error) => {
        this.toastService.erro("Erro", error.error.message)
      },
      complete: () => {
        this.loadingEstoqueERP = false;
      }
    })
  }

  getDepositos(instancia: string) {
    this.painelService.getDepositosPorInstancia(instancia).subscribe({
      next: (data) => {
        this.depositos = data;

        if(this.tipoTransferencia == 'T'){
          this.depositoOrigem = this.depositos.filter(deposito => deposito.cdTipoDep == 'A' && deposito.fgPadrao == true)[0]
          this.depositoDestino = this.depositoOrigem

          this.depositosDestino = this.depositos.filter(deposito => deposito.cdTipoDep == 'A')
          this.depositosOrigem = this.depositosDestino



        }else if(this.tipoTransferencia == 'D'){
          this.depositoOrigem = this.depositos.filter(deposito => deposito.cdTipoDep == 'A' && deposito.fgPadrao == true)[0]
          this.depositoDestino = this.depositos.filter(deposito => deposito.cdTipoDep == 'E' && deposito.fgPadrao == true)[0]

          this.depositosOrigem = this.depositos.filter(deposito => deposito.cdTipoDep == 'A' && deposito.fgPadrao == true)
          this.depositosDestino = this.depositos.filter(deposito => deposito.cdTipoDep == 'E' && deposito.fgPadrao == true)
        }
        else if(this.tipoTransferencia == 'R') {
          this.depositoOrigem = this.depositos.filter(deposito => deposito.cdTipoDep == 'E' && deposito.fgPadrao == true)[0]
          this.depositoDestino = this.depositos.filter(deposito => deposito.cdTipoDep == 'A' && deposito.fgPadrao == true)[0]

          this.depositosOrigem = this.depositos.filter(deposito => deposito.cdTipoDep == 'E' && deposito.fgPadrao == true)
          this.depositosDestino = this.depositos.filter(deposito => deposito.cdTipoDep == 'A' && deposito.fgPadrao == true)
        }

        this.getEstoqueErp();
        
      },
      error: (error) => {
        this.toastService.erro("Erro", error.error.message)
      },
    });
  }

  formatDate(data: string) {
    return moment(data).format('DD/MM/yyyy');
  }

  buscaSaldoDestino(insumo: string) {
    if (this.ordemDestino.instancia)
      if (
        this.ordemDestino.itens.filter((i) => i.cdInsumo == insumo).length > 0
      ){
        return this.ordemDestino.itens.filter((i) => i.cdInsumo == insumo)[0].qtSaldoReceber - this.ordemDestino.itens.filter((i) => i.cdInsumo == insumo)[0].qtCompromissadaOs;
      }

    return 0;
  }

  calculaMaximo(insumo: OrdemInsumoItems): number{

    let valorMaximo = 0;
    let saldoDestino = this.buscaSaldoDestino(insumo.cdInsumo);

    if(this.tipoTransferencia == 'R'){
      valorMaximo = insumo.qtAjustada - insumo.qtRetirada - insumo.qtRecebida + insumo.qtDevolvida + insumo.qtEnviada - insumo.qtCompromissadaOs

      valorMaximo = valorMaximo < Number(this.estoqueMaterialErp[insumo.cdInsumoErp] || 0) ?  valorMaximo : Number(this.estoqueMaterialErp[insumo.cdInsumoErp] || 0);
    }else if(this.tipoTransferencia == 'D') {
      valorMaximo = (insumo.qtRetirada + insumo.qtRecebida) - (Number(this.getBaixado(insumo.cdInsumo) || 0) + insumo.qtDevolvida + insumo.qtEnviada)

      valorMaximo = valorMaximo < Number(this.estoqueMaterialErp[insumo.cdInsumoErp] || 0) ?  valorMaximo : Number(this.estoqueMaterialErp[insumo.cdInsumoErp] || 0);
    }else if(this.tipoTransferencia == 'T'){
      valorMaximo = (insumo.qtRetirada + insumo.qtRecebida) - (insumo.qtDevolvida + (Number(this.getBaixado(insumo.cdInsumo)) || 0) + insumo.qtEnviada) - insumo.qtCompromissadaOs
      
      valorMaximo = saldoDestino < valorMaximo ? saldoDestino : valorMaximo;
    }

    

      return valorMaximo;

  }

  buscaOrdemDestino() {
    this.loadingDestino = true;

    if (this.ordemDestino.noOs == this.ordemOrigem.noOs) {
      this.toastService.alerta(
        '',
        'A ordem destino digitada é a mesma a de origem'
      );
    } else {
      this.painelService
        .getOrdemOs(this.ordemDestino.noOs, this.ordemOrigem.instancia)
        .subscribe({
          next: (data) => {
            this.ordemDestino = data;
          },
          error: (error) => {
            this.toastService.erro('Erro', error.error.message);
            this.loadingDestino = false;
          },
          complete: () => {
            this.loadingDestino = false;
          },
        });
    }
  }

  getInsumosBaixado(instancia: string, os: string, insumo: string) {
    this.painelService.getInsumosBaixados(instancia, os, insumo).subscribe({
      next: (value) => {
        this.insumosConsumidos = value;
        console.log(this.insumosConsumidos);

        this.insumosConsumidos.forEach((x) => {
          this.insConsumidos[x.cdInsumo] = x.quantidade;
        });
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {},
    });
  }

  getBaixado(insumo: string): Number {
    return this.insConsumidos[insumo] || 0;
  }

  transferir() {
    let transfers: OrdemInsumoTransferencia = {} as OrdemInsumoTransferencia;
    this.loadingOperacao = true;

    
    transfers.instancia = this.ordemOrigem.instancia
    transfers.os = this.ordemOrigem.id
    transfers.tipo = this.tipoTransferencia
    transfers.depositoOrigem = this.depositoOrigem.id

    let mensagem = ""

    if(this.tipoTransferencia == 'T'){
      transfers.osDestino = this.ordemDestino.id
      transfers.depositoDestino = this.depositoDestino.id

      if(this.posicaoDestino != undefined)
        transfers.posicaoDestino = this.posicaoDestino.id
      mensagem = "Transferência"
    }

    if(this.tipoTransferencia == 'R' && this.posicaoDestino?.id){
      transfers.depositoDestino = this.depositoDestino.id

      if(this.posicaoDestino != undefined)
        transfers.posicaoDestino = this.posicaoDestino.id
      mensagem = "Retirada"
    }

    if(this.tipoTransferencia == 'D'){
      mensagem = "Devolução"
    }

    transfers.itens = []

    for (const [key, value] of Object.entries(this.transferencias)) {
      let transf = value as OrdemInsumoTransferenciaItem;

      if (transf.quantidade > 0) {
        let item: OrdemInsumoTransferenciaItem = {} as OrdemInsumoTransferenciaItem;

        item.insumo = transf.insumo
        item.quantidade = transf.quantidade

        transfers.itens.push(item);
      }
    }


    if(transfers.itens.length <= 0) {
      this.toastService.info("","Digite a quantidade para realizar a operação");
      this.loadingOperacao = false;

    }else if((this.tipoTransferencia == 'R' || this.tipoTransferencia == 'T') && transfers.posicaoDestino == undefined){
      this.toastService.info("","Necessario informar a posição do depósito");
      this.loadingOperacao = false;

    }
    else{

      transfers.usuario = localStorage.getItem("cdUsuarioErp") || ""
      this.painelService.postTransferir(transfers).subscribe({
        next: (data) => {
          this.toastService.sucesso("Sucesso", mensagem + " realizada com sucesso");
          this.router.navigate(["painelinsumos", "detalhes", this.activatedRoute.snapshot.paramMap.get('id')])
          this.loadingOperacao = false;
        },
        error: (error) => {
          console.error(error)
          this.toastService.erro("Erro", error.error)
          this.loadingOperacao = false;
        }
      })
    }
  }

  statusOrdem(fgStatus: string) {

    let retorno = "";
    switch(fgStatus){
      case "F":
        retorno = "Fechada";
        break;
      case "E":
        retorno = "Excluída";
        break;
      case "A":
        retorno = "Aberta";
    }

    return retorno;
  }
}
